goog.provide('el8.appchart.reportFeeds.contentRenderer');

goog.require('el8.data.base');
goog.require('el8.data.referencedUsers');

goog.require('el8.template.render.reportFeedItem');
goog.require('el8.template.button');
goog.require('el8.appchart.reportFeeds.actions');
goog.require('el8.template.appchart.reportFeeds');

el8.appchart.reportFeeds.contentRenderer = function(item, hasActions) {

    var mClass = item.getModelClass();

    switch (mClass) {
        case "Report":
            return function(item, feedId) {
                var content = el8.template.render.reportFeedItem.contentReport(
                    $.extend(item.asSoyMap(), {
                        feedItemId  : item.getFeedItemId(),
                        hasActions: el8Globals['TEASE'] ? false : (hasActions !== false),
                        currentUserIsPhysician : el8.data.currUser.isPhysician(),
                        referringThreads: item.getReferringThreads().map(el8.model.toSoyMapFn),
                        externalReportAttachments: item.getExternalReportAttachmentSoyMaps(), // overwrite
                    })
                );

                var buttons = el8.template.button.buttons({
                    buttons: el8.appchart.reportFeeds.actions.contentButtons(item),
                    feedItemId: item.getFeedItemId()
                });
                return $(el8.template.appchart.reportFeeds.feedItemContent({
                    content: content,
                    buttons: buttons
                }));
            };
        case "LabOrder":
            return function(item, feedId) {
                var contentMap = item.asSoyMap();
                contentMap['patient'] = el8.ptdata.currPatient.asSoyMap();
                contentMap['order'] = contentMap; // for child template reuse
                contentMap['canDocumentCollection'] = el8Globals.FEATURES.InHouseLabWorkflow && item.isIsInHouse();

                var content = el8.template.render.reportFeedItem.contentLabOrder(contentMap);

                var buttons = el8.template.button.buttons({
                    buttons: el8.appchart.reportFeeds.actions.contentButtons(item),
                    feedItemId: item.getFeedItemId()
                });
                return $(el8.template.appchart.reportFeeds.feedItemContent({
                    content: content,
                    buttons: buttons
                }));
            };
        case "ImagingOrder":
        case "SleepOrder":
        case "CardiacOrder":
        case "PulmonaryOrder":
            return function(item, feedId) {
                var contentMap = item.asSoyMap();
                contentMap['patient'] = el8.ptdata.currPatient.asSoyMap();
                var content = el8.template.render.reportFeedItem.contentAncillaryOrder(contentMap);
                var buttons = el8.template.button.buttons({
                    buttons: el8.appchart.reportFeeds.actions.contentButtons(item),
                    feedItemId: item.getFeedItemId()
                });
                return $(el8.template.appchart.reportFeeds.feedItemContent({
                    content: content,
                    buttons: buttons
                }));
            };
        case "ReferralOrder":
            return function(item, feedId) {
                var contentMap = item.asSoyMap();
                contentMap['patient'] = el8.ptdata.currPatient.asSoyMap();
                contentMap['order'] = contentMap; // for child template reuse
                var content = el8.template.render.reportFeedItem.contentReferralOrder(contentMap);

                var buttons = el8.template.button.buttons({
                    buttons: el8.appchart.reportFeeds.actions.contentButtons(item),
                    feedItemId: item.getFeedItemId()
                });
                return $(el8.template.appchart.reportFeeds.feedItemContent({
                    content: content,
                    buttons: buttons
                }));
            };
        case "VisitNote":
            return function(item, feedId) {
                var contentMap = item.asSoyMap();
                contentMap['feedId'] = feedId;
                contentMap['feedItemId'] = item.getFeedItemId();
                contentMap['assessment']['feedItemId'] = item.getFeedItemId();
                var content = el8.template.render.reportFeedItem.contentImportedVisit(contentMap);

                var buttons = el8.template.button.buttons({
                    buttons: el8.appchart.reportFeeds.actions.contentButtons(item),
                    feedItemId: item.getFeedItemId()
                });
                return $(el8.template.appchart.reportFeeds.feedItemContent({
                    content: content,
                    buttons: buttons
                }));
            };
        case "NonvisitNote":
            return function(item, feedId) {
                var contentMap = item.asSoyMap();
                contentMap['feedId'] = feedId;
                contentMap['feedItemId'] = item.getFeedItemId();
                var content = el8.template.render.reportFeedItem.contentImportedNonvisit(contentMap);

                var buttons = el8.template.button.buttons({
                    buttons: el8.appchart.reportFeeds.actions.contentButtons(item),
                    feedItemId: item.getFeedItemId()
                });
                return $(el8.template.appchart.reportFeeds.feedItemContent({
                    content: content,
                    buttons: buttons
                }));
            };
        default:
            break;
    }
};

